import { Component, Input, OnChanges, SimpleChanges, ViewChild } from "@angular/core";
import { FormGroup, FormBuilder, Validators } from '@angular/forms';

import { Observable } from 'rxjs';

import { DatePickerComponent } from '../../../../../shared/date-picker';
import { Insurance, InsuranceProviders } from '../../../../../_models';
import { Product } from '../../../../../_models/Interfaces';
import { AgreementComponent } from '../agreement';

@Component({
    selector: 'app-insurance',
    templateUrl: './insurance.component.html',
    styleUrls: ['../agreement/agreement.component.scss'],
    providers: [InsuranceProviders]
})
export class InsuranceComponent implements OnChanges {
    @Input() unitId: number;
    @ViewChild(AgreementComponent) agreement: AgreementComponent;
    form: FormGroup;
    product: Product = {
        endpoint: 'unit',
        id: this.unitId
    };
    file: any;
    isNew: boolean = true;
    request$: Observable<any>;
    invalid: boolean = true;
    @ViewChild('startDate') startDate: DatePickerComponent;
    @ViewChild('endDate') endDate: DatePickerComponent;
    @ViewChild('formEl') formEl;
    validation_messages = {
        'name': [{ type: 'required', message: 'Campo requerido.' }],
        'date_begin': [{ type: 'required', message: 'Campo requerido.' }],
        'date_begin_page': [{ type: 'required', message: 'Campo requerido.' }],
        'date_expires': [{ type: 'required', message: 'Campo requerido.' }],
        'date_expires_page': [{ type: 'required', message: 'Campo requerido.' }],
        'amount': [{ type: 'required', message: 'Campo requerido.' }],
        'amount_page': [{ type: 'required', message: 'Campo requerido.' }],
        'insurer': [{ type: 'required', message: 'Campo requerido.' }],
        'annual_fee': [{ type: 'required', message: 'Campo requerido.' }],
        'payment_period_in_days': [{ type: 'required', message: 'Campo requerido.' }]
    }
    additionalEntry = 'Nuevo';
    constructor(private data: Insurance, private _fb: FormBuilder) {
        this.form = this._fb.group({
            'insurance_id': [0],
            'file': [''],
            'name': [null, Validators.compose([Validators.required])],
            'date_begin': [null, Validators.compose([Validators.required])],
            'date_begin_page': [null, Validators.compose([Validators.required])],
            'date_expires': [null, Validators.compose([Validators.required])],
            'date_expires_page': [null, Validators.compose([Validators.required])],
            'amount': ['', Validators.compose([Validators.required])],
            'amount_page': [null, Validators.compose([Validators.required])],
            'insurer': [null, Validators.compose([Validators.required])],
            'annual_fee': [null, Validators.compose([Validators.required])],
            'payment_period_in_days': [null, Validators.compose([Validators.required])],
            'comments': [null]
        });
        this.form.valueChanges.subscribe(formValue => {
            let invalidPrev: boolean = !this.isNew && !this.form.valid;
            let invalidNew: boolean =
                this.isNew && (!this.form.valid || !this.form.value.file || !this.form.value.name);
            this.invalid = invalidPrev || invalidNew;
            this.makeRequest();
        });
    }

    ngOnChanges(changes: SimpleChanges) {
        if ('unitId' in changes) {
            let unitId = changes['unitId'].currentValue;
            if (unitId) {
                this.product.id = unitId;
                this.getData();
            }
        }
    }
    changeAgreement(selected: any) {
        if (this.isNewAgreement(selected)) {
            this.isNew = true;
            this.form.controls.insurance_id.setValue(0);
            this.form.reset();
            this.startDate.clear();
            this.endDate.clear();
            return;
        }
        this.isNew = false;
        this.form.setValue(selected.pick(this.form.value));
        this.startDate.setDate(this.form.value.date_begin);
        this.endDate.setDate(this.form.value.date_expires);
    }
    // reference: https://stackoverflow.com/questions/44072909/using-reactive-form-validation-with-input-type-file-for-an-angular-app/44238894
    // fix: formcontrolname not yet implemented for input type=file
    onFileChange($event) {
        this.file = $event.target.files[0]; // <--- File Object for future use.
        this.form.controls['file'].setValue(this.file ? this.file.name : ''); // <-- Set Value for Validation
    }

    getData() {
        this.data.getFromProduct(this.product).subscribe(value => {
            this.changeAgreement(value);
        });
    }
    agreementUpdated() {
        this.getData();
    }
    makeRequest() {
        if (this.data) {
            let form = new FormData(this.formEl.nativeElement);
            if (this.form.value.insurance_id) {
                form.set('insurance_id', this.form.value.insurance_id);
            }
            else {
                form.set('insurance_id', '0');
                form.set('file', this.file);
            }
            form.set('date_begin', this.form.value.date_begin);
            form.set('date_expires', this.form.value.date_expires);

            this.request$ = this.data.post(this.product, form);
        }
    }
    private startChanged(data) {
        this.form.controls.date_begin.setValue(data.string);
    }
    private endChanged(data) {
        this.form.controls.date_expires.setValue(data.string);
    }
    private isNewAgreement(agreement) {
        return (agreement == this.additionalEntry) || (this.data && this.data.empty());
    }
}



// WEBPACK FOOTER //
// /Users/cmedina/Code/motto_frontend/src/app/theme/pages/aside-left-display-disabled/units/insurance/insurance.component.ts